import { render, staticRenderFns } from "./MismatchCard.vue?vue&type=template&id=2d55b8e7&scoped=true&"
import script from "./MismatchCard.vue?vue&type=script&lang=js&"
export * from "./MismatchCard.vue?vue&type=script&lang=js&"
import style0 from "./MismatchCard.vue?vue&type=style&index=0&id=2d55b8e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55b8e7",
  null
  
)

export default component.exports